module.exports = __webpack_public_path__ + "img/dealer.43e2631d.png";